export default __webpack_public_path__ + "static/media/image20.6b1a1fa1.png";